import * as THREE from "three"

import Home from "./Home.js";

export default class ScreenRenderer {
    constructor() {
        this.home = new Home()
        this.sizes = this.home.sizes
        this.scene = this.home.scene
        this.canvas = this.home.canvas
        this.camera = this.home.camera


        // Set Instance
        this.setInstance()

        // console.log("Hello")
    }

    setInstance() {
        this.instance = new THREE.WebGLRenderer({
            canvas: this.canvas,
            antialias: true,
            powerPreference: "high-performance"
        })
        this.instance.outputColorSpace = THREE.SRGBColorSpace
        this.instance.toneMapping = THREE.ACESFilmicToneMapping
        this.instance.setClearColor("#000000")
        this.instance.toneMappingExposure = 1.75
        this.instance.shadowMap.enabled = false
        this.instance.shadowMap.type = THREE.PCFSoftShadowMap
        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(this.sizes.pixelRatio)

    }

    resize() {
        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(this.sizes.pixelRatio)
    }

    update() {
        this.instance.render(this.scene, this.camera.instance)
    }
}
